module.exports = __webpack_public_path__ + "public/SiteImages/facebook.svg?42e67848";